export const FILTER_ACTIONS = {
    MATCH: 'Match',
    INCLUDES: 'Includes'
};

export const FILER_TYPES = {
    INPUT: { action: FILTER_ACTIONS.INCLUDES, id: 'Input' },
    SELECT: { action: FILTER_ACTIONS.MATCH, id: 'Select' }
};

export const UNASSIGNED_VALUE = 'UNASSIGNED';
